import { render, staticRenderFns } from "./Questions.view.vue?vue&type=template&id=2c7f6086&scoped=true"
import script from "./Questions.view.vue?vue&type=script&lang=js"
export * from "./Questions.view.vue?vue&type=script&lang=js"
import style0 from "./Questions.view.vue?vue&type=style&index=0&id=2c7f6086&prod&lang=scss&scoped=true"
import style1 from "./Questions.view.vue?vue&type=style&index=1&id=2c7f6086&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7f6086",
  null
  
)

export default component.exports